// restore-payload.service.ts
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface PayloadData {
  payload: any;
  form: any;
  categoryId: number;
  dataCategory: any;
}

@Injectable({
  providedIn: 'root'
})
export class RestorePayloadService {
  // ✅ Almacenamiento en memoria (no localStorage)
  private savedPayload: PayloadData | null = null;
  
  // ✅ Observable para notificar cambios
  private payloadSubject = new BehaviorSubject<PayloadData | null>(null);
  public payload$ = this.payloadSubject.asObservable();

  constructor() {}

  /**
   * Guarda el payload en memoria
   */
  savePayload(payload: any, form: any, categoryId: number, dataCategory: any): void {
    this.savedPayload = {
      payload,
      form,
      categoryId,
      dataCategory
    };
    this.payloadSubject.next(this.savedPayload);
    console.log('✅ Payload guardado en memoria:', this.savedPayload);
  }

  /**
   * Recupera el payload guardado
   */
  getPayload(): PayloadData | null {
    return this.savedPayload;
  }

  /**
   * Verifica si hay payload guardado
   */
  hasPayload(): boolean {
    return this.savedPayload !== null;
  }

  /**
   * Restaura el payload (devuelve los datos para usarlos)
   */
  restorePayload(): PayloadData | null {
    if (!this.savedPayload) {
      console.warn('⚠️ No hay payload para restaurar');
      return null;
    }
    
    console.log('🔄 Payload restaurado:', this.savedPayload);
    return this.savedPayload;
  }

  /**
   * Limpia el payload guardado
   */
  clearPayload(): void {
    this.savedPayload = null;
    this.payloadSubject.next(null);
    console.log('🗑️ Payload eliminado de memoria');
  }

  /**
   * Actualiza el payload guardado (útil si cambia algo)
   */
  updatePayload(payload: any, form: any, categoryId: number, dataCategory: any): void {
    if (this.savedPayload) {
      this.savedPayload = {
        payload: payload || this.savedPayload.payload,
        form: form || this.savedPayload.form,
        categoryId: categoryId || this.savedPayload.categoryId,
        dataCategory: dataCategory || this.savedPayload.dataCategory
      };
      this.payloadSubject.next(this.savedPayload);
    }
  }
}